<template>
    <div class="CSChatThai" style="background: #2562af;">
     <div style="background: #2562af !important; padding: 10px;">

  <v-btn icon @click="goback()" style="margin: 0 !important;">
        <v-icon class="white--text" style="font-size: 24px;">chevron_left</v-icon>
      </v-btn>
 

 <span style="color: white;font-weight: 800; margin-left: 25vw;">โปรไฟล์</span>

</div>



<div style="padding: 10px; border-top-left-radius: 20px;border-top-right-radius: 20px;background: #fafafa;">
<v-layout row wrap>
  <v-flex xs12 xl12 lg12 md12 sm12>
    <div style="display: flex;justify-content: center;">
      <div class="image-upload">
    <!-- <img class="imageProfile alligator-turtle" @click="uppic"  :src="my_profile_picture"/> -->
<!-- {{my_profile_picture}} -->
    <v-img
            :src="my_profile_picture"
            aspect-ratio="1"
            class="grey lighten-2 imageProfile alligator-turtle"
            v-if="my_profile_picture"
            @click="uppic"
          >
            <template v-slot:placeholder>
              <v-layout
                fill-height
                align-center
                justify-center
                ma-0
              >
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-layout>
            </template>
          </v-img>

          <v-img
            class="grey lighten-2 imageProfile alligator-turtle"
            v-else
            @click="uppic"
          >
          </v-img>



      <label for="file-input" class="SettingImgBtn">
    เปลี่ยนรูป
  </label>

  <input id="file-input" type="file" @change="previewImageprofiles" accept="image/*"/>
</div>
      </div>
      <div style="margin-top: 10px;">
<div class="detailBG" @click="gotopath('/edit_displayname')">
<p class="HeadersDetail">ชื่อแสดง</p>
<p class="Detail">{{displayname}} </p>
</div>
<div class="detailBG" @click="gotopath('/edit_status')">
<p class="HeadersDetail" >สถานะ</p>
<p class="Detail">{{(status)? status:'-'}} </p>

</div>
<div class="detailBGEmail" >
<p class="HeadersDetail" >อีเมล</p>
<p class="Detail">{{(email)? email:'-'}} </p>
</div>

</div>
    </v-flex>
  </v-layout>
  </div>






    </div>
</template>

<script>
import gql from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { Momenttime, Decode, Encode } from '@/services'

const get_detailuser = gql`
query MyQuery($user_id: uuid) {
  users(where: {user_id: {_eq: $user_id}}) {
    profile_picture
    email
    display_name
    status
  }
}
`

export default {
  data: () => ({
    detailUser: {},
    user_id: '',
    Authorization: {},
    displayname: '',
    status: '',
    email: '',
    my_profile_picture: '',
    backend: process.env.VUE_APP_API,
    selectFile: {},
    changeState: ''
  }),
  apollo: {
  },
  computed: {
    ...sync('*')
  },
  created () {
    // this.$session.set('user_id', Encode.encodeToken('eeb8855b-b330-4bc5-a1d1-e7f3c3350277'))
    this.user_id = Decode.decodeToken(localStorage.getItem('user_id'))
    this.Authorization = {headers: {'Authorization': 'Bearer ' + Decode.decodeToken(localStorage.getItem('auth_token'))}}
    this.getDetail()
  },
  methods: {
    getDetail () {
      this.$apollo.query({
        query: get_detailuser,
        variables: {
          user_id: this.user_id
        },
        fetchPolicy: 'no-cache'
      }).then((response) => {
        this.detailUser = response.data.users[0]
        this.displayname = this.detailUser.display_name
        this.status = this.detailUser.status
        this.email = this.detailUser.email
        if (this.detailUser.profile_picture) {
          this.my_profile_picture = this.backend + this.detailUser.profile_picture
        } else {
          this.my_profile_picture = ''
        }
        
      })
    },
    uppic () {
      $('#file-input').click()
    },
    previewImageprofiles (data) {
      this.selectFile = data.target.files[0]
      var uploadFile = new FormData()
      // var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
      // this.token = decoded['tokenuser']
      uploadFile.append('file', this.selectFile, this.selectFile.name)
      // uploadFile.append('tokenuser', decoded['tokenuser'])
      this.axios.post(process.env.VUE_APP_API + '/updateProfilePicture', uploadFile, this.Authorization).then((response) => {
        if (response.data.message === 'success') {
          this.my_profile_picture = response.data.data.url
          // this.getDetail()
        }
      })
    },
    // changeState (data) {
    //   this.state = data
    // },
    gotopath (path) {
      this.$router.push(path)
    },
    goback () {
      this.$router.back()
      // iframe.contentWindow.history.go(-1)
    }
  }
    
} 
</script>
<style type="text/css" scoped>
.CSChatThai {
 /*font-family: 'CS ChatThaiUI' !important;*/
 word-wrap: break-word;
}
>>>.v-text-field--solo input {
    margin: auto !important;
    margin-top: auto !important;
}
>>>.v-text-field--solo>.v-input__control>.v-input__slot {
    /*background: white !important;
    border-radius: 10px !important;*/
    background: #3978c7 !important;
    border-radius: 38px !important;
}

>>>.v-input input:focus .v-text-field .v-input__prepend-inner {
  color: red;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  box-shadow: none;
  font-size: 15px;
}
.colorAvatar {
  color: #2562af !important;
}
.timeListChat {
  color: #adadad;
  font-size: 10px;
}
/*>>>.theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
  border: 0 !important;
}*/

>>>.theme--light.v-input:not(.v-input--is-disabled) input {
    color: #5b8cbd !important;
}

>>>.v-badge--bottom .v-badge__badge {
  /*bottom: -8px !important;*/
  border: #2562af 2px solid !important;
  bottom: -6px !important;
}
>>>.v-badge__badge {
  height: 14px !important;
  width: 14px !important;
  right: -16px !important;
}
>>>.v-list--two-line .v-list__tile {
  height: 65px !important;
}
.v-text-field--box .v-input__slot, .v-text-field--solo .v-input__slot {
  height: 30px;
}
.defaultPicOnline {
  margin-right: 5px;
  cursor: pointer;
  background: white;
}

>>>.v-text-field--solo input {
    margin: auto !important;
    margin-top: auto !important;
}
>>>.v-text-field--solo>.v-input__control>.v-input__slot {
    background: #f3f3f3 !important;
    border-radius: 7px !important;
    border: 2px solid #5b8cbd !important;
}

>>>.v-input input:focus .v-text-field .v-input__prepend-inner {
  color: red;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  box-shadow: none;
}
/*>>>.theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
  border: 0 !important;
}*/
>>>.v-input__icon .v-input__icon--prepend-inner .v-icon {
  font-size: 13px !important;
}
>>>.v-icon {
    font-size: inherit;
  }

  >>>.v-list--two-line .v-list__tile {
  height: 65px !important;
}

.theme--light.v-list {
    background: #fafafa;
    color: rgba(0,0,0,.87);
}
.createGroupStyle {
  background: #f3f3f3;padding: 10px; cursor: pointer;
}
.HeadersDetail {
  margin-bottom: 0 !important;
  color: #5b8cbd8c;
  font-size: 11px; 
}
.Detail {
  color: #5b8cbd;
  font-size: 16px;
}
.detailBG {
  padding: 2px 10px;
  padding-top: 20px;
  cursor: pointer;
}
.detailBG:hover {
  background: #2196f312;
}
.detailBGEmail {
  padding: 2px 10px;
  padding-top: 20px;
}
.imageProfile {
  height: 50vw;
  width: 50vw;
  border-radius: 20px;
  cursor: pointer !important;
}
.image-upload>input {
  display: none;
}
.image-upload {
      display: inline-block;
    position: relative;
    border-radius: 20px;
    overflow: hidden;
    height: 50vw;
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
.SettingImgBtn {
    display: block;
    overflow: hidden;
    position: absolute;
    bottom: -20px;
    right: -20px;
    line-height: 1;
    width: 40px;
    height: 30px;
    bottom: 0;
    left: 0;
    line-height: 30px;
    width: 100%;
    text-align: center;
    cursor: pointer;
    color: #fff;
    background: rgba(0, 0, 0, .5);
}

.SettingImgBtn:hover {
    display: block;
    overflow: hidden;
    position: absolute;
    bottom: -20px;
    right: -20px;
    line-height: 1;
    width: 40px;
    height: 50%;
    bottom: 0;
    left: 0;
    line-height: 30px;
    width: 100%;
    text-align: center;
    cursor: pointer;
    color: #fff;
    background: rgba(0, 0, 0, .75);
}
</style>


// WEBPACK FOOTER //
// src/components/mail/My_Profile.vue